export const SHOPPING_CART_CACHE = 'shopping-cart-cache-v1';
export const SHOPPING_CART_LAST_ORDER_CACHE = 'shopping-cart-cache-last-order-v1';
export const ORDER_TYPE_CACHE = 'order-type-cache-v1';
export const USER_ADDRESS_CACHE = 'user-address-cache-v2';
export const SW_CACHE_EXIPIRATION = 'sw-cache-expiration';

export const DEPRECATED_CACHE = ['user-address-cache-v1'];
